
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptedSolutionButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptedSolutionMessage"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageId"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solution"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageConversation"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MessageBoard"},"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../MessageConversation.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../MessageBoard.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/messages/MessageId.fragment.graphql").definitions));


    module.exports = doc
  
